export const SMSES_GET_MESSAGE_CONTROL_PARAMETERS_START = 'SMSES_GET_MESSAGE_CONTROL_PARAMETERS_START';
export const SMSES_GET_MESSAGE_CONTROL_PARAMETERS_SUCCESS = 'SMSES_GET_MESSAGE_CONTROL_PARAMETERS_SUCCESS';
export const SMSES_GET_MESSAGE_CONTROL_PARAMETERS_FAIL = 'SMSES_GET_MESSAGE_CONTROL_PARAMETERS_FAIL';

export const SMSES_SET_MESSAGE_CONTROL_PARAMETERS_SUCCESS = 'SMSES_SET_MESSAGE_CONTROL_PARAMETERS_SUCCESS';

export const SMSES_SEND_MESSAGE_START = 'SMSES_SEND_MESSAGE_START';
export const SMSES_SEND_MESSAGE_SUCCESS = 'SMSES_SEND_MESSAGE_SUCCESS';
export const SMSES_SEND_MESSAGE_FAIL = 'SMSES_SEND_MESSAGE_FAIL';

export const GET_CONTACT_PHONES_START = 'CREATE_CONTACT_PHONES_START';
export const GET_CONTACT_PHONES_SUCCESS = 'CREATE_CONTACT_PHONES_SUCCESS';
export const GET_CONTACT_PHONES_FAIL = 'CREATE_CONTACT_PHONES_FAIL';
